import {
  FormLabel,
  TextField,
  Typography,
  FormControl,
  type SxProps,
} from '@mui/material';

export const FormTextField = ({
  title,
  placeholder,
  value,
  onChange,
  sx,
}: {
  title: string;
  placeholder: string;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  sx?: SxProps;
}) => {
  return (
    <FormControl sx={{ width: '100%', ...sx }}>
      <FormLabel>
        <Typography variant='subtitle1'>{title}</Typography>
      </FormLabel>
      <TextField
        inputProps={{
          style: { height: '24px' },
          'data-testid': 'eon-backup-application-name',
        }}
        placeholder={placeholder}
        disabled={false}
        value={value}
        onChange={onChange}
      />
    </FormControl>
  );
};
